import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {useLands} from '#/hooks/query/use-lands';
import {useUnlistedLands} from '#/hooks/query/use-unlisted-lands';
import {Land, UnlistedLand} from 'shareland-common';
import {useQueryParams} from 'use-query-params';

type UseUnlistedLandResult = {
  data: Land | UnlistedLand | undefined;
  isLoading: boolean;
};
export const useSelectedLand = (): UseUnlistedLandResult => {
  const [{landToken}] = useQueryParams<SLQueryParamConfig>();

  const {data: lands, isLoading: landsIsLoading} = useLands();
  const land = lands?.find(land => land.tokenSymbol === landToken);
  const useLand = !!land || landsIsLoading;

  const {data: unlistedLands, isLoading: unlistedLandsIsLoading} = useUnlistedLands(!useLand);

  if (useLand) {
    return {
      data: land,
      isLoading: landsIsLoading,
    };
  }

  return {
    data: unlistedLands?.find(land => land.tokenSymbol === landToken),
    isLoading: unlistedLandsIsLoading,
  };
};
